import React from 'react';
import {Card, Flex, List} from "antd";
import {PricePopUpCardProps} from "../../../models";
import {MdAvTimer, MdCheckCircle, MdOutlineCheckCircle, MdOutlineRadioButtonUnchecked} from "react-icons/md";
import {StyledCard} from "./PricePopUp.styled";
import style from "./PricePopUp.module.scss";

const PricePopUpCard = ({price, rentType, isActive ,onActive,id}: PricePopUpCardProps) => {

    return (
            <Flex justify={"space-between"} align={"center"}>
                <Flex gap={"small"}>
                    {/*<span><MdAvTimer/></span>*/}
                    <span className={style.greyFont}>{rentType}</span>
                </Flex>
                <Flex gap={"small"}align={"center"}>
                    <span>{price.toString().replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        ","
                    )} </span>
                    <span className={style.price}>   تومان </span>
                </Flex>
            </Flex>
    );
};

export default PricePopUpCard;
